import { render, staticRenderFns } from "./ListDeals.vue?vue&type=template&id=1c92cd7a&scoped=true&"
import script from "./ListDeals.vue?vue&type=script&lang=js&"
export * from "./ListDeals.vue?vue&type=script&lang=js&"
import style0 from "./ListDeals.vue?vue&type=style&index=0&id=1c92cd7a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c92cd7a",
  null
  
)

component.options.__file = "ListDeals.vue"
export default component.exports